import { floor, max } from "./math/Math"

export default function toFloorMin0(value: number | null): number {
  return max(0, floor(value as number))
}
